import { BrowserRouter } from "react-router-dom";
import { ApiClientProvider } from "../api/ApiClientContext";
import { apiClient } from "../api/client";
import { AuthProvider } from "../auth/AuthProvider";
import { CatalogProvider } from "../catalog/CatalogProvider";
import { CollectionProvider } from "../collection/CollectionProvider";
import { CollectionViewProvider } from "../collection/CollectionViewProvider";
import { NetworkStatusProvider } from "../offline/NetworkStatusContext";
import { GridDensityProvider } from "../ui/GridDensityContext";
import { AppRoutes } from "../routing/AppRoutes";
import { CollectionUndoToast } from "../components/CollectionUndoToast";

export function App() {
  return (
    <BrowserRouter>
      <NetworkStatusProvider>
        <ApiClientProvider client={apiClient}>
          <AuthProvider client={apiClient}>
            <CollectionProvider client={apiClient}>
              <CollectionViewProvider client={apiClient}>
                <CatalogProvider client={apiClient}>
                  <GridDensityProvider>
                    <AppRoutes />
                    <CollectionUndoToast />
                  </GridDensityProvider>
                </CatalogProvider>
              </CollectionViewProvider>
            </CollectionProvider>
          </AuthProvider>
        </ApiClientProvider>
      </NetworkStatusProvider>
    </BrowserRouter>
  );
}
